import { render } from "./preview.vue?vue&type=template&id=98fc3774"
import script from "./preview.vue?vue&type=script&lang=js"
export * from "./preview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__